import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 * On every route change (pathname change), scroll the window to the top.
 * - Skips when the URL has a hash (e.g. /#contact) so anchor links still
 *   land on the targeted section.
 * - Uses an "instant" jump (no smooth scroll) so the new page renders
 *   correctly from the top, not mid-scroll.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor links handle scroll
    // Use 'auto' (instant) to avoid a visible scroll animation on route change
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
